import { useMemo } from 'react';
import { useComponentEntries } from '../hook.component-entries.js';

function useTeacherEntries(timespan) {
  const entries = useComponentEntries(timespan);
  const entriesGroupedByComponent = useMemo(() => Object.entries(entries.data?.reduce((acc, curr) => {
    acc[curr.component.id] ??= [];
    acc[curr.component.id]?.push(curr);
    return acc;
  }, {}) ?? {}).map(([id, groupedEntries]) => ({
    key: id,
    groupedEntries
  })), [entries.data]);
  return useMemo(() => entriesGroupedByComponent.reduce((acc, curr) => {
    if (curr.groupedEntries[0]?.status.score?.pointsPossible) {
      acc.selfCorrectingEntries.push(curr);
    } else {
      acc.notSelfCorrectingEntries.push(curr);
    }
    return acc;
  }, {
    selfCorrectingEntries: [],
    notSelfCorrectingEntries: []
  }), [entriesGroupedByComponent]);
}

export { useTeacherEntries };
//# sourceMappingURL=hook.teacher-entries.js.map
